import Fa from "./Translation/Fa.json";
import En from "./Translation/En.json";
import i18n from "i18next";

import { GetStorage } from "./Utils/Storage";
import { initReactI18next } from "react-i18next";

const resources = {
  fa: {
    translation: Fa,
  },
  en: {
    translation: En,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: GetStorage("LNG")?.toLocaleLowerCase() || "fa",

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
